import { graphql } from '@graphql/__generated'

export const GET_EVENTS_BY_IDS = graphql(`
  query getEventsByIds($eventIds: [String!]!) {
    getEventsByIds(eventIds: $eventIds) {
      ...EventFull
    }
  }
`)
